<template>
  <v-menu offset-y left :nudge-bottom="8" content-class="user-menu">
    <template v-slot:activator="{ on, attrs }">
      <button type="button" class="user-menu-trigger" v-bind="attrs" v-on="on">
        <v-icon class="user-menu-icon">$vuetify.icons.user_circle</v-icon>
        <span v-if="!compact" class="user-menu-name">{{ displayName }}</span>
        <v-icon small class="user-menu-chevron">$vuetify.icons.caret_down</v-icon>
      </button>
    </template>
    <div class="user-menu-panel">
      <div class="user-menu-header">
        <div class="user-menu-identity">
          <span class="user-menu-header-name">{{ displayName }}</span>
          <span v-if="subtitle" class="user-menu-subtitle">{{ subtitle }}</span>
        </div>
      </div>
      <v-divider class="user-menu-divider" />
      <v-list dense class="user-menu-list">
        <slot />
      </v-list>
    </div>
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue'
import { User } from '@/store/authentication'

export default Vue.extend({
  props: {
    user: { type: Object as () => User, required: true },
    subtitle: { type: String, default: '' },
  },
  computed: {
    displayName(): string {
      const { firstName, lastName } = this.user
      return `${firstName || ''} ${lastName || ''}`.trim()
    },
    compact(): boolean {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
})
</script>

<style lang="scss" scoped>
.user-menu-trigger {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
  font: inherit;

  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.1);
    outline: none;
  }
}

.user-menu-icon {
  font-size: 28px !important;
  opacity: 0.9;
}

.user-menu-name {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-chevron {
  opacity: 0.75;
}

.user-menu-panel {
  min-width: 240px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: calc(14px * 1.05);
  color: #231f20;
}

.user-menu-header {
  padding: 14px 16px 12px 18px;
}

.user-menu-identity {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.user-menu-header-name {
  font-size: 1em;
  font-weight: 600;
  color: #231f20;
  line-height: 1.3;
}

.user-menu-subtitle {
  font-size: calc(12em / 14);
  color: #231f20;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-divider {
  margin: 0;
}

.user-menu-list {
  padding: 6px !important;
  color: #231f20;
}

:deep(.user-menu-list .v-list-item__title) {
  color: #231f20 !important;
  font-size: 1em !important;
}

:deep(.user-menu) {
  margin-top: 8px;
  border-radius: 12px;
  box-shadow:
    0 1px 3px rgba(15, 23, 42, 0.08),
    0 8px 24px rgba(15, 23, 42, 0.12);
  border: 1px solid #e5e7eb;
}
</style>
